import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { DashboardModel } from '../../dashboard/model/dashboard/dashboard.model';
import { environment } from './../../../environments/environment';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  appurl = environment.apiUrl + '/v2/api/studies';
  studyInfo: any;
  access = JSON.parse(localStorage.getItem('access'));

  constructor(private http: HttpClient, private apiRequest:ApiRequestService) { }

  getStudies(data: string) {
      if (data === 'not present') {
          this.studyInfo = {user_uuid: this.access.id};
      }
      else {
         this.studyInfo = {user_uuid: this.access.id, project_uuid: data};
      }
      const httpPostOptions = {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: true
      };

      let opt = {};
      opt['httpOptions'] = httpPostOptions;
      return this.apiRequest.request('POST','/v2/api/studies',this.studyInfo,opt)
        .pipe(map(data => {
          let _data:any = data;
          return _data;
        }));
    // return this.http.post<DashboardModel>(this.appurl, this.studyInfo, httpPostOptions);
  }
  getPaginationStudies(pageData:any, data: any) {
    if (data === 'not present') {
      this.studyInfo = {user_uuid: this.access.id, pageNo: pageData['pageNo'], pageLimit: pageData['pageLimit'], studyMode: pageData['studyMode']};
    }
    else {
      this.studyInfo = {user_uuid: this.access.id, project_uuid: data,pageNo: pageData['pageNo'], pageLimit: pageData['pageLimit'], studyMode: pageData['studyMode']};
    }
    const httpPostOptions = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true
    };

    let opt = {};
      opt['httpOptions'] = httpPostOptions;
      return this.apiRequest.request('POST','/v2/api/studies',this.studyInfo,opt)
        .pipe(map(data => {
          let _data:any = data;
          return _data;
        }));
    // return this.http.post<DashboardModel>(this.appurl, this.studyInfo, httpPostOptions);

  }
}

